import { Component, computed, DOCUMENT, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  FooterComponent,
  HeaderComponent,
  OverlayComponent,
} from '@components';
import { CONFIG } from '@config';
import { provideTranslationDictionaryMapping, TranslateService } from '@i18n';
import {
  OverlayService,
  OverlayState,
  ResetService,
  SESSION_EXPIRED_STORAGE_KEY,
} from '@registration';
import posthog from 'posthog-js';
import { OverlayTranslationDictionary } from './i18n/overlay-translation-dictionary.interface';
import { translation } from './i18n/translation.constant';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, OverlayComponent],
  templateUrl: './app.component.html',
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class AppComponent implements OnInit {
  private readonly document = inject(DOCUMENT);
  private readonly resetService = inject(ResetService);
  readonly config = inject(CONFIG);
  readonly overlayService = inject(OverlayService);
  readonly OverlayState = OverlayState;
  private readonly translateService = inject(
    TranslateService<OverlayTranslationDictionary>,
  );
  readonly overlayMessage = computed(() => {
    const key = this.overlayService.messageKey();
    return key ? this.translateService.translate(key) : '';
  });

  ngOnInit(): void {
    this.handleBaseHrefChange();

    posthog.setPersonProperties({
      BRAND: this.config.domainId,
    });

    if (sessionStorage.getItem(SESSION_EXPIRED_STORAGE_KEY)) {
      sessionStorage.removeItem(SESSION_EXPIRED_STORAGE_KEY);
      this.resetService.reset();
    }

    this.resetService.startInactivityWatcher();
  }

  private handleBaseHrefChange(): void {
    const current =
      this.document.querySelector('base')?.getAttribute('href') ?? '/';
    const stored = sessionStorage.getItem('app_base_href');

    if (stored && stored !== current) {
      sessionStorage.clear();
    }

    sessionStorage.setItem('app_base_href', current);
  }
}
